// extracted by mini-css-extract-plugin
export var content = "styles-module--content--ca14b";
export var gif = "styles-module--gif--9fe1f";
export var hint = "styles-module--hint--0c9b1";
export var text = "styles-module--text--7ff6f";
export var wrapper = "styles-module--wrapper--8cb15";